import React from "react"
import { connect } from "react-redux"

import { smartFill, testUsers } from "../../tools/smartFill"
import { hideModal } from "common/services/modals/actions"

const SmartFillOptionsList = props => (
  <div className="spCard spShadow-half">
    <h4>Test users for smart fill</h4>
    <ul>
      {testUsers.map((item, index) => (
        <li className="DebugModal-smart-fill-user-item" key={index}>
          <span onClick={() => props.doSmartFill(item)}>{item.email}</span>
        </li>
      ))}
    </ul>
  </div>
)

// $FlowFixMe TODO: plz add type when updating
export default connect(
  null,
  dispatch => ({
    doSmartFill: user => {
      smartFill(user)
      dispatch(hideModal("debug"))
    },
  }),
)(SmartFillOptionsList)
